import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import { fetchUnactiveUsers, fetchUnactiveUsersCount, setReportsFilters } from '../../action';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { fetchCities, fetchFilials } from '../../action/handbook';
import ErrorContainer from '../utils/ErrorContainer';
import Select from 'react-select';
import DatePicker, { registerLocale } from "react-datepicker";
import ru from "date-fns/locale/ru";
import "react-datepicker/dist/react-datepicker.css";
import { utils, writeFileXLSX } from 'xlsx';
import swal from 'sweetalert';
registerLocale("ru", ru);

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

export default function UnactiveClients() {
    const data = useSelector(state => state.reports.unactiveClients);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);
    const cities = useSelector(state => state.handbook.cities);
    const citiesCount = useSelector(state => state.handbook.count.cities);
    const citiesLoading = useSelector(state => state.loaders.cities);
    const { count, filters, loading } = data;

    const dispatch = useDispatch();

    useEffect(() => {
        const getData = async () => {
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
            if ((isEmpty(cities) || cities.length < citiesCount)) await dispatch(fetchCities(true));
        };
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('unactiveClients', updated));
    }

    const onSearch = () => {
        dispatch(fetchUnactiveUsersCount());
    }

    const onChangeDateInput = (date) => {
        const updated = { ...filters, last_order_lte: new Date(moment(date).endOf('day'))};
        dispatch(setReportsFilters('unactiveClients', updated));
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.city || !filters.city.value)) return true;
        return false;        
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label" style={{ gap: '5px' }}>
                    <h3 className="kt-portlet__head-title">
                        Неактивные клиенты
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Дата *</label>
                        <div style={{ width: '200px' }}>
                        <DatePicker
                            portalId="root-portal"
                            selected={filters.last_order_lte}
                            onChange={onChangeDateInput}
                            minDate={new Date(moment().subtract(3, 'month').startOf('month'))}
                            maxDate={new Date()}
                            dateFormat="dd.MM.yyyy"
                            locale="ru"
                            className="form-control"
                            wrapperClassName="react-datepicker-wrapper w-100"
                            showTimeSelect={false}
                        />
                        </div>
                    </div>
                    <div>
                        <label>Город *</label>
                        <div style={{ width: '200px' }}>
                        <Select
                            isLoading={loading || citiesLoading}
                            isDisabled={loading || citiesLoading}
                            closeMenuOnSelect={true}
                            options={cities.map((city) => ({ label: city.name, value: city.id }))} 
                            onChange={setFilters('city')}
                            placeholder="Город"
                            noOptionsMessage={() => 'Нет филиалов'}
                            value={filters.city}                    
                        />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                    </div>
                </div>
            </div>
        );
    }

    const renderAdress = (item) => {
        if (!item) return 'Не определен';
        let cityName = (item.city && item.city.name) ? item.city.name : null;
        if (!cityName && item.city) {
            const entity = cities.find((city) => city.id === (item.city.id || item.city));
            if (entity && entity.name) cityName = entity.name;
        }
        return `${cityName ? cityName : '---'}, ${item.street}, ${item.house}`;
    };

    const renderCity = (city) => {
        if (!city) return;
        let id;
        
        if (city != null && typeof city === 'object') {
            if (city.name) return city.name;
            id = parseInt(city.id);
        } else {
            id = parseInt(city);
        }
        
        if (!id || isEmpty(cities)) return;
        const entity = cities.find((city) => city.id === id);
        if (isEmpty(entity)) return;
        return entity.name;
    }

    const renderUserAddress = (user) => {
        if (!user || user.street == null) return 'Не указан';
    
        const text = [`ул. ${user.street}`];
    
        if (user.house != null) text.push(`д. ${user.house}`);
        if (user.entrance != null) text.push(`под. ${user.entrance}`);
        if (user.room != null) text.push(`кв. ${user.room}`);
        if (user.area != null) text.unshift(`район ${user.area}`);
    
        return text.join(', ');
    };
    
    const onExport = async () => {
        const data = await dispatch(fetchUnactiveUsers());
        if (!data || isEmpty(data)) return swal({
            title: 'Ошибка',
            text: `Ошибка при импорте данных`,
            icon: 'error',
            dangerMode: true
        });;

        const exportData = data.map((user) => ({
                'Имя': user.name || 'Не указано',
                'Телефон': user.phone || 'Не указан',
                'Город': renderCity(user.city) || 'Не указан',
                'Дата последнего заказа': user.last_order ? moment(user.last_order).format('DD.MM.YYYY') : '-',
                'Дата регистрации': moment(user.created_at).format('DD.MM.YYYY'),
                'Филиал': renderAdress(user.point) || 'Не указан',
                'Адрес доставки': renderUserAddress(user) || 'Не указан',
        }));

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        const cityText = filters.city && filters.city.label ? filters.city.label : null;
        const dateText = filters.last_order_lte ? moment(filters.last_order_lte).format('DD.MM.YYYY') : null;

        utils.book_append_sheet(wb, ws, "Неактивные клиенты");
        writeFileXLSX(wb, `Неактивные клиенты ${cityText ? cityText : ''} ${dateText ? dateText : ''}.xlsx`);
    }

    const renderBody = () => {
        if (loading || pointLoading || citiesLoading) return <div style={styles.loading}><Loader /></div>;        

        if (count == null) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="unactiveClients" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        {`Клиенты - неактивные. Кол-во: ${count}`}
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar">
                    <div className="dateBlock" style={{ marginRight: 10 }}>
                        <button disabled={count == null || count === 0} onClick={onExport} className="btn btn-dark btn-icon-sm">Экспорт</button>
                    </div>
                </div>
            </div>
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}